import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InvoiceV1Page from "../InvoiceV1Page";
import InvoiceV2Page from "../InvoiceV2Page";

/**
 * Combined Invoice Page with tabs for V1 and V2
 * - V1 tab: Read-only historical invoice submissions
 * - V2 tab: New invoice submission and management
 */
const InvoicePage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t("invoice.title")}
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="invoice tabs"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tab
            label={t("invoice.v2.tab")}
            id="tab-v2"
            aria-controls="tabpanel-v2"
          />
          <Tab
            label={t("invoice.v1.tab")}
            id="tab-v1"
            aria-controls="tabpanel-v1"
          />
        </Tabs>
      </Box>

      {/* V2 Tab Panel */}
      <Box
        role="tabpanel"
        hidden={activeTab !== 0}
        id="tabpanel-v2"
        aria-labelledby="tab-v2"
      >
        {activeTab === 0 && <InvoiceV2Page />}
      </Box>
      {/* V1 Tab Panel */}
      <Box
        role="tabpanel"
        hidden={activeTab !== 1}
        id="tabpanel-v1"
        aria-labelledby="tab-v1"
      >
        {activeTab === 1 && <InvoiceV1Page />}
      </Box>
    </Box>
  );
};

export default InvoicePage;
